export const ContractType = {
  PaperContract: "Amethyst",
  HostingContract: "Kyanite"
};

export const ContractTypeDescription = {
  PaperContract: "PaperContract",
  HostingContract: "HostingContract"
};
